let lastProgress = 0;

function updateCSSVariable(value, animate = true) {
  const numValue = parseFloat(value) || 0;
  
  if (animate && lastProgress !== numValue) {
    document.documentElement.style.setProperty('--co-progress', `${lastProgress}%`);
    
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        document.documentElement.style.setProperty('--co-progress', `${numValue}%`);
        lastProgress = numValue;
      });
    });
  } else {
    document.documentElement.style.setProperty('--co-progress', `${numValue}%`);
    lastProgress = numValue;
  }
}

function detectAndHandleOpana() {
  const element = document.getElementById('co-progress-bar-factor');
  
  if (element) {
    const value = element.value || element.textContent || 0;
    updateCSSVariable(value);
    
    if (element.tagName === 'INPUT' || element.tagName === 'TEXTAREA') {
      element.addEventListener('input', () => updateCSSVariable(element.value || 0));
      element.addEventListener('change', () => updateCSSVariable(element.value || 0));
    }
    
    const elementObserver = new MutationObserver(() => {
      updateCSSVariable(element.value || element.textContent || 0);
    });
    
    elementObserver.observe(element, {
      attributes: true,
      childList: true,
      characterData: true,
      subtree: false,
    });
  } else {
    updateCSSVariable(0, false);
  }
}

function observeOpanaChanges() {
  const parent = document.body;
  
  const observer = new MutationObserver(() => {
    detectAndHandleOpana();
  });
  
  observer.observe(parent, {
    childList: true,
    subtree: true,
  });
  
  detectAndHandleOpana();
}

document.addEventListener('DOMContentLoaded', observeOpanaChanges);